import { render, staticRenderFns } from "./show-pagination.vue?vue&type=template&id=d5d163ce&"
import script from "./show-pagination.vue?vue&type=script&lang=js&"
export * from "./show-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports